const apiUrl = process.env.REACT_APP_API_URL || 'http://10.5.10.59:8081/applicantapi';

export abstract class endpoints {
    static readonly jobOffers = `${apiUrl}/JobOffers`;

    static readonly files = `${apiUrl}/Files`;
}
